import React from "react";
import { Col, Row, Button, } from '@deere/ux.uxframe-react'
import { ERR_TITLE_CONNERR,ERR_DESC_CONNERR, ERR_GOBACK_BUTTON_LABEL,ERR_GOTOSEARCH_BUTTON_LABEL,ERR_TITLE_REQUEST_NUMBER } from "../../utils/errorLiterals";
import { SAM_URL,CONTACTUS_URL} from "../../utils/constEnvVariables";

export default function ErrorPage(props) {
const goHelpDesk = () => window.open(CONTACTUS_URL);
const errorUser = props.location? props.location.state.errorUser : '';
const goReqAccess = () => window.open(SAM_URL + errorUser);

const errorDetails = props.location ? props.location.state : {errorTitle: ERR_TITLE_CONNERR,errorDescription:ERR_DESC_CONNERR, errorUrl:''};
const accessError = errorDetails.errorTitle === ERR_TITLE_REQUEST_NUMBER? false:true;
const goBackTitle = accessError? ERR_GOBACK_BUTTON_LABEL: ERR_GOTOSEARCH_BUTTON_LABEL;
const goSearch = () => window.open("/","_self"); 
const goBack = () => window.history.back()

        return (
                <main id="content" className="container-fluid bg-gray pt-4 pb-5">
                        <Row className="align-items-center h-100">
                                <Col md="24" className="col w-100 text-center">
                                        <h1 className="display-6">{errorDetails.errorTitle}</h1>
                                        <svg focusable="false" aria-hidden="true" fill="#666666" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style={{width: "200px", height: "200px"}}><path d="M0 0h24v24H0z" fill="none"></path><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"></path></svg>
                                        <p className="w-100">{errorDetails.errorDescription}</p>
                                        <p className="text-muted w-100">Timestamp: {Date().toLocaleString()}</p>
                                        <p className="text-muted w-100">{errorDetails.errorUrl}</p>
                                        <div className="pt-5">
                                                <Button variant="secondary" onClick={accessError?goBack:goSearch}>{goBackTitle}</Button>
                                                <Button variant="secondary" onClick={goHelpDesk}>Contact Help Desk</Button>
                                                <Button variant="primary" onClick={goReqAccess}>Request Access</Button>
                                        </div>
                                </Col>
                        </Row>
                </main>
        );
}
